module.exports = __webpack_public_path__ + "static/media/YF81_0.20abdc7d.jpg";